// src/data/servicesData.js

export const servicesData = [
  //Nhóm 1: Thiết Kế Thương Hiệu & Quảng Cáo
  {
    slug: "thiet-ke-thuong-hieu",
    title: "Thiết Kế Thương Hiệu",
    topSections: [
      { title: "Thiết Kế Thương Hiệu" },
      {
        text: "Chúng tôi xây dựng thương hiệu mạnh mẽ thông qua thiết kế logo, bộ nhận diện, mascot và slogan, giúp doanh nghiệp tạo dấu ấn độc đáo trên thị trường.",
      },
      {
        text: "Đội ngũ chuyên gia sáng tạo của chúng tôi kết hợp chiến lược và nghệ thuật để đảm bảo mọi sản phẩm đều phản ánh đúng tầm nhìn và giá trị thương hiệu.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage:
      "/assets/img/service/thiet-ke-thuong-hieu/thiet-ke-thuong-hieu-banner.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Thiết kế thương hiệu là bước nền tảng để doanh nghiệp xây dựng hình ảnh chuyên nghiệp và nhận diện mạnh mẽ. Chúng tôi nghiên cứu kỹ thị trường, khách hàng mục tiêu và phong cách thương hiệu để tạo ra các thiết kế đột phá, dễ nhận diện và ghi nhớ.",
    listItems: [
      ["Thiết Kế Logo", "Bộ Nhận Diện Thương Hiệu", "Mascot Thương Hiệu"],
      ["Slogan & Tagline", "Hướng Dẫn Thương Hiệu", "Ứng Dụng Truyền Thông"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Mỗi thiết kế được đảm bảo tính chiến lược, khác biệt và phù hợp với mọi nền tảng truyền thông. Chúng tôi tạo ra bộ nhận diện dễ nhận biết, linh hoạt và tạo kết nối cảm xúc với khách hàng.",
    secondaryImages: [
      {
        src: "/assets/img/service/thiet-ke-thuong-hieu/thiet-ke-thuong-hieu-banner1.webp",
        col: 8,
      },
      {
        src: "/assets/img/service/thiet-ke-thuong-hieu/thiet-ke-thuong-hieu-banner2.webp",
        col: 4,
      },
    ],
    additionalText: [
      {
        text: "Chúng tôi giúp thương hiệu kể câu chuyện riêng, tạo ấn tượng lâu dài và nổi bật giữa đám đông.",
      },
      {
        text: "Mục tiêu là mỗi thiết kế đều truyền tải thông điệp rõ ràng, đồng thời phản ánh cá tính và giá trị cốt lõi của thương hiệu.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "thiet-ke-quang-cao",
    title: "Thiết Kế Quảng Cáo",
    topSections: [
      { title: "Thiết Kế Quảng Cáo" },
      {
        text: "Chúng tôi cung cấp dịch vụ thiết kế profile, báo cáo thường niên, brochure và các ấn phẩm quảng cáo khác, giúp thương hiệu nổi bật và truyền tải thông điệp hiệu quả.",
      },
      {
        text: "Đội ngũ sáng tạo của chúng tôi kết hợp mỹ thuật và chiến lược marketing để đảm bảo mỗi sản phẩm quảng cáo vừa thu hút, vừa mang giá trị thương hiệu cao.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage:
      "/assets/img/service/thiet-ke-quang-cao/thiet-ke-quang-cao-banner.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Thiết kế quảng cáo là công cụ quan trọng giúp thương hiệu giao tiếp trực tiếp với khách hàng. Chúng tôi nghiên cứu nội dung, hình ảnh và phong cách thiết kế để tạo ra các ấn phẩm bắt mắt, chuyên nghiệp và đồng nhất với thương hiệu.",
    listItems: [
      ["Thiết Kế Profile Công Ty", "Báo Cáo Thường Niên", "Brochure & Catalog"],
      [
        "Poster & Flyer",
        "Ấn Phẩm Marketing",
        "Ứng Dụng Truyền Thông Đa Nền Tảng",
      ],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Mỗi ấn phẩm quảng cáo đều được thiết kế để nổi bật, dễ nhớ và phù hợp với chiến lược thương hiệu. Chúng tôi chú trọng sự hài hòa về hình ảnh, màu sắc và thông điệp để tạo sự ấn tượng lâu dài.",
    secondaryImages: [
      {
        src: "/assets/img/service/thiet-ke-quang-cao/thiet-ke-quang-cao-banner1.webp",
        col: 8,
      },
      {
        src: "/assets/img/service/thiet-ke-quang-cao/thiet-ke-quang-cao-banner2.webp",
        col: 4,
      },
    ],
    additionalText: [
      {
        text: "Chúng tôi biến ý tưởng sáng tạo thành các ấn phẩm quảng cáo hiệu quả, giúp thương hiệu nổi bật và kết nối với khách hàng.",
      },
      {
        text: "Mục tiêu là đảm bảo mọi thiết kế quảng cáo đều chuyên nghiệp, đồng bộ và phản ánh chính xác giá trị thương hiệu.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "thiet-ke-bao-bi",
    title: "Thiết Kế Bao Bì",
    topSections: [
      { title: "Thiết Kế Bao Bì" },
      {
        text: "Chúng tôi thiết kế bao bì không chỉ để bảo vệ sản phẩm mà còn kể câu chuyện thương hiệu, tạo ấn tượng mạnh mẽ và thu hút ánh nhìn của khách hàng trên kệ hàng.",
      },
      {
        text: "Phương pháp tiếp cận của chúng tôi kết hợp giữa chức năng, sáng tạo và nghiên cứu thị trường để mang đến bao bì nổi bật, khác biệt và thúc đẩy doanh số.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage:
      "/assets/img/service/thiet-ke-bao-bi/thiet-ke-bao-bi-banner.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Bao bì là điểm chạm quan trọng của thương hiệu. Chúng tôi tạo ra những thiết kế vừa ấn tượng về mặt thị giác, vừa tiện dụng, đồng thời thể hiện đúng tinh thần nhận diện thương hiệu.",
    listItems: [
      [
        "Bao Bì Sản Phẩm",
        "Chất Liệu Thân Thiện Môi Trường",
        "Thiết Kế Kết Cấu",
      ],
      ["Kể Chuyện Thương Hiệu", "Tạo Ấn Tượng Trưng Bày", "Giải Pháp Sáng Tạo"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Thiết kế bao bì của chúng tôi kết hợp hài hòa giữa tính thẩm mỹ và công năng. Mỗi chi tiết đều được chăm chút để nâng cao trải nghiệm người dùng và gia tăng độ nhận diện thương hiệu.",
    secondaryImages: [
      {
        src: "/assets/img/service/thiet-ke-bao-bi/thiet-ke-bao-bi-banner1.webp",
        col: 8,
      },
      {
        src: "/assets/img/service/thiet-ke-bao-bi/thiet-ke-bao-bi-banner2.webp",
        col: 4,
      },
    ],
    additionalText: [
      {
        text: "Chúng tôi tập trung vào việc tạo ra bao bì truyền tải được giá trị thương hiệu và để lại dấu ấn lâu dài trong tâm trí khách hàng.",
      },
      {
        text: "Từ ý tưởng đến sản xuất, đội ngũ Design24 đảm bảo mọi chi tiết đều phục vụ mục tiêu marketing và bán hàng của bạn.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "thiet-ke-bang-hieu-showroom",
    title: "Thiết Kế Bảng Hiệu & Showroom",
    topSections: [
      { title: "Thiết Kế Bảng Hiệu & Showroom" },
      {
        text: "Chúng tôi thiết kế bảng hiệu và không gian trưng bày, tạo ấn tượng mạnh mẽ, thu hút khách hàng ngay từ cái nhìn đầu tiên.",
      },
      {
        text: "Đội ngũ thiết kế của chúng tôi kết hợp sáng tạo và kiến thức về trải nghiệm khách hàng để đảm bảo mọi không gian và bảng hiệu đều nổi bật và chuyên nghiệp.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage:
      "/assets/img/service/thiet-ke-bang-hieu-cua-hang-showroom/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Thiết kế bảng hiệu, cửa hàng và showroom là cách để thương hiệu hiện diện mạnh mẽ và tạo dấu ấn ngay lập tức với khách hàng. Chúng tôi nghiên cứu không gian, ánh sáng, màu sắc và phong cách thiết kế để tạo ra trải nghiệm thị giác độc đáo và nhất quán với thương hiệu.",
    listItems: [
      [
        "Thiết Kế Bảng Hiệu Ngoài Trời",
        "Thiết Kế Showroom",
        "Thiết Kế Cửa Hàng",
      ],
      [
        "Trưng Bày Sản Phẩm",
        "Thiết Kế Không Gian Nội Thất",
        "Tối Ưu Trải Nghiệm Khách Hàng",
      ],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Mỗi bảng hiệu và không gian trưng bày được thiết kế để gây ấn tượng mạnh, nổi bật giữa các đối thủ cạnh tranh. Chúng tôi chú trọng sự hài hòa về màu sắc, ánh sáng và bố cục để tối ưu trải nghiệm khách hàng.",
    secondaryImages: [
      {
        src: "/assets/img/service/thiet-ke-bang-hieu-cua-hang-showroom/1.webp",
        col: 8,
      },
      {
        src: "/assets/img/service/thiet-ke-bang-hieu-cua-hang-showroom/2.webp",
        col: 4,
      },
    ],
    additionalText: [
      {
        text: "Chúng tôi biến không gian và bảng hiệu thành công cụ marketing trực quan, giúp thương hiệu ghi dấu ấn mạnh mẽ và bền lâu.",
      },
      {
        text: "Mục tiêu là tạo ra những thiết kế không chỉ đẹp mắt mà còn thúc đẩy trải nghiệm và tương tác của khách hàng.",
        className: "mt-2",
      },
    ],
  },
  // Nhóm 2: Thiết Kế Website & Ứng Dụng
  {
    slug: "thiet-ke-website-ung-dung",
    title: "Thiết Kế Website & Ứng Dụng Di Động",
    topSections: [
      { title: "Thiết Kế Website & Ứng Dụng Di Động" },
      {
        text: "Chúng tôi thiết kế giao diện người dùng (UI/UX) cho website và ứng dụng di động, giúp trải nghiệm khách hàng trở nên trực quan, dễ sử dụng và thu hút.",
      },
      {
        text: "Đội ngũ thiết kế của chúng tôi kết hợp sáng tạo và phân tích hành vi người dùng để đảm bảo sản phẩm vừa đẹp mắt, vừa tối ưu trải nghiệm và hiệu quả kinh doanh.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/thiet-ke-website-ung-dung/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Thiết kế website và ứng dụng di động là cầu nối quan trọng giữa thương hiệu và khách hàng. Chúng tôi nghiên cứu hành vi người dùng, chuẩn hóa trải nghiệm và tạo ra giao diện thân thiện, dễ sử dụng và hiện đại.",
    listItems: [
      ["Thiết Kế UI/UX", "Thiết Kế Web Responsive", "Thiết Kế App Mobile"],
      [
        "Prototype & Wireframe",
        "Tối Ưu Trải Nghiệm Người Dùng",
        "Thiết Kế Thương Hiệu Trực Tuyến",
      ],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Mỗi sản phẩm được thiết kế để thân thiện với người dùng, trực quan và dễ tương tác. Chúng tôi đảm bảo website và app không chỉ đẹp mắt mà còn tăng tỷ lệ chuyển đổi và giữ chân khách hàng.",
    secondaryImages: [
      { src: "/assets/img/service/thiet-ke-website-ung-dung/1.webp", col: 8 },
      { src: "/assets/img/service/thiet-ke-website-ung-dung/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi giúp thương hiệu hiện diện chuyên nghiệp trên mọi nền tảng kỹ thuật số, nâng cao trải nghiệm người dùng và giá trị thương hiệu.",
      },
      {
        text: "Mục tiêu là mỗi sản phẩm đều tối ưu hóa trải nghiệm, tăng tương tác và tạo ấn tượng lâu dài với khách hàng.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "thiet-ke-ux-ui",
    title: "Thiết Kế UX/UI",
    topSections: [
      { title: "Thiết Kế UX/UI" },
      {
        text: "Chúng tôi tạo ra trải nghiệm người dùng (UX) và giao diện người dùng (UI) trực quan, thu hút và ấn tượng, đảm bảo tương tác liền mạch trên mọi thiết bị.",
      },
      {
        text: "Quy trình thiết kế tập trung vào nghiên cứu người dùng, xây dựng wireframe và nguyên mẫu (prototype) để mang lại sản phẩm số chất lượng cao.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/thiet-ke-ux-ui/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Thiết kế UX/UI là yếu tố cốt lõi cho sự thành công trong môi trường số. Chúng tôi chú trọng đến tính dễ sử dụng, khả năng tiếp cận và tính thẩm mỹ để tạo nên giao diện khiến người dùng yêu thích và ghi nhớ.",
    listItems: [
      ["Wireframing", "Prototyping", "Nghiên Cứu Người Dùng"],
      ["Thiết Kế Tương Tác", "Thiết Kế Giao Diện", "Giao Diện Responsive"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Thiết kế UX/UI của chúng tôi được tối ưu cho sự tương tác và hiệu quả. Mỗi sản phẩm mang đến trải nghiệm thống nhất, hấp dẫn và phản ánh rõ nét bản sắc thương hiệu.",
    secondaryImages: [
      { src: "/assets/img/service/thiet-ke-ux-ui/1.webp", col: 8 },
      { src: "/assets/img/service/thiet-ke-ux-ui/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi nâng tầm trải nghiệm số bằng cách kết hợp giữa công năng và câu chuyện thị giác, tạo ra sản phẩm vừa dễ dùng vừa truyền cảm hứng.",
      },
      {
        text: "Mỗi giao diện được thiết kế để nâng cao tính tiện dụng và thúc đẩy các chỉ số tương tác của người dùng.",
        className: "mt-2",
      },
    ],
  },
  // Nhóm 3: Sản Xuất Nội Dung & Quảng Cáo
  {
    slug: "san-xuat-tvc-video",
    title: "Sản Xuất TVC/Video",
    topSections: [
      { title: "Sản Xuất TVC/Video" },
      {
        text: "Chúng tôi cung cấp dịch vụ sản xuất video quảng cáo chất lượng cao, từ ý tưởng đến hậu kỳ, giúp thương hiệu truyền tải thông điệp một cách sống động và thu hút.",
      },
      {
        text: "Với đội ngũ chuyên nghiệp và quy trình tinh gọn, chúng tôi đảm bảo video hoàn thiện nhanh chóng, đúng tiến độ và phù hợp ngân sách từ 9 triệu đồng.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/san-xuat-tvc-video/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Sản xuất TVC/Video là công cụ mạnh mẽ để thương hiệu kết nối với khách hàng. Chúng tôi nghiên cứu kịch bản, phong cách hình ảnh và âm thanh để tạo ra các video ấn tượng, dễ nhớ và truyền cảm hứng.",
    listItems: [
      ["Sáng Tạo Kịch Bản", "Quay Phim Chuyên Nghiệp", "Hậu Kỳ & Biên Tập"],
      ["Hiệu Ứng Đặc Biệt", "Âm Thanh & Nhạc Nền", "Tối Ưu Cho Mạng Xã Hội"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Quy trình sản xuất của chúng tôi đảm bảo mỗi video đều sáng tạo, chuyên nghiệp và hiệu quả. Chúng tôi kết hợp hình ảnh, âm thanh và câu chuyện để video trở nên sống động, thu hút và dễ lan tỏa.",
    secondaryImages: [
      { src: "/assets/img/service/san-xuat-tvc-video/1.webp", col: 8 },
      { src: "/assets/img/service/san-xuat-tvc-video/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Mỗi sản phẩm video đều được thiết kế để phản ánh đúng thông điệp và cá tính của thương hiệu, tạo ấn tượng mạnh với khách hàng.",
      },
      {
        text: "Chúng tôi cam kết hoàn thành sản phẩm chất lượng cao trong thời gian ngắn, chỉ từ 3 ngày, giúp doanh nghiệp triển khai chiến dịch kịp thời.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "san-xuat-video",
    title: "Video Production",
    topSections: [
      { title: "Sản Xuất Video" },
      {
        text: "Chúng tôi thực hiện các video chất lượng cao, truyền tải câu chuyện thương hiệu, thu hút khán giả và thúc đẩy hiệu quả kinh doanh.",
      },
      {
        text: "Từ ý tưởng đến bản dựng cuối cùng, đội ngũ Design24 đảm nhận toàn bộ quy trình: viết kịch bản, quay, dựng và hậu kỳ với sự chính xác và sáng tạo.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/san-xuat-video/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Sản xuất video là công cụ mạnh mẽ để kể câu chuyện thương hiệu. Chúng tôi tạo ra các video cho marketing, mạng xã hội, truyền thông nội bộ và sự kiện, giúp truyền tải thông điệp một cách cuốn hút và hiệu quả.",
    listItems: [
      ["Viết Kịch Bản", "Storyboard", "Quay Phim"],
      ["Dựng Phim", "Hậu Kỳ", "Hoạt Hình"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Quy trình sản xuất video của chúng tôi tập trung vào sự sáng tạo, chất lượng và tính kể chuyện. Mỗi video đều được thiết kế phù hợp với mục tiêu của khách hàng và tạo sự kết nối mạnh mẽ với khán giả.",
    secondaryImages: [
      { src: "/assets/img/service/san-xuat-video/1.webp", col: 8 },
      { src: "/assets/img/service/san-xuat-video/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi tạo ra những video không chỉ chuyên nghiệp về mặt hình ảnh mà còn truyền tải thông điệp rõ ràng, ấn tượng và dễ nhớ.",
      },
      {
        text: "Mỗi dự án đều được đội ngũ Design24 chăm chút để phản ánh đúng bản sắc thương hiệu và chạm tới cảm xúc người xem.",
        className: "mt-2",
      },
    ],
  },
  {
    slug: "motion-design",
    title: "Motion Design",
    topSections: [
      { title: "Motion Design" },
      {
        text: "Chúng tôi tạo ra những motion graphics sống động, giúp truyền tải câu chuyện thương hiệu một cách hiệu quả thông qua animation, video và hình ảnh tương tác.",
      },
      {
        text: "Đội ngũ Design24 kết hợp sự sáng tạo và kỹ thuật để sản xuất nội dung thu hút, truyền cảm hứng và gắn kết khán giả trên nhiều nền tảng.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/motion-design/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Motion design nâng cao khả năng truyền thông bằng cách thêm chuyển động vào nội dung hình ảnh. Chúng tôi sản xuất các animation giúp củng cố thông điệp thương hiệu và để lại ấn tượng lâu dài.",
    listItems: [
      ["Logo Chuyển Động", "Video Giải Thích", "Hoạt Họa Mạng Xã Hội"],
      ["Chuyển Động UI", "Animation Infographic", "Nội Dung Tương Tác"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Dịch vụ motion design của chúng tôi kết hợp storytelling với animation để tạo ra nội dung vừa bắt mắt, vừa truyền tải thông tin, đồng thời giữ vững bản sắc thương hiệu.",
    secondaryImages: [
      { src: "/assets/img/service/motion-design/1.webp", col: 8 },
      { src: "/assets/img/service/motion-design/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi biến ý tưởng thành hiện thực bằng các animation thu hút, vừa truyền tải thông điệp vừa nâng cao trải nghiệm thương hiệu.",
      },
      {
        text: "Các sản phẩm motion design được tối ưu cho nhiều kênh truyền thông, đảm bảo tính nhất quán và tạo tác động mạnh mẽ ở mọi điểm chạm.",
        className: "mt-2",
      },
    ],
  },

  // Nhóm 4: Digital Marketing & Chiến Lược Thương Hiệu
  {
    slug: "digital-marketing",
    title: "Digital Marketing",
    topSections: [
      { title: "Digital Marketing" },
      {
        text: "Chúng tôi cung cấp dịch vụ marketing trực tuyến toàn diện, bao gồm SEO, quảng cáo trên mạng xã hội và Google Ads, giúp thương hiệu tăng trưởng mạnh mẽ trên nền tảng số.",
      },
      {
        text: "Đội ngũ chuyên gia Digital Marketing của chúng tôi kết hợp chiến lược, phân tích dữ liệu và sáng tạo nội dung để đạt hiệu quả tối ưu cho mỗi chiến dịch.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/digital-marketing/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Digital Marketing là chìa khóa để thương hiệu tiếp cận khách hàng một cách chính xác và hiệu quả. Chúng tôi nghiên cứu hành vi người dùng, tối ưu công cụ tìm kiếm và triển khai quảng cáo trực tuyến nhằm tăng độ nhận diện và doanh số.",
    listItems: [
      ["SEO Website", "Quảng Cáo Google Ads", "Quảng Cáo Facebook & Instagram"],
      [
        "Chiến Lược Nội Dung",
        "Quản Lý Mạng Xã Hội",
        "Phân Tích & Tối Ưu Chiến Dịch",
      ],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Chúng tôi xây dựng các chiến dịch Digital Marketing dựa trên dữ liệu, sáng tạo và chiến lược. Mỗi chiến dịch được thiết kế để tăng tương tác, chuyển đổi và nâng cao giá trị thương hiệu trên môi trường số.",
    secondaryImages: [
      { src: "/assets/img/service/digital-marketing/1.webp", col: 8 },
      { src: "/assets/img/service/digital-marketing/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi giúp thương hiệu kết nối đúng khách hàng, tối ưu chi phí và gia tăng hiệu quả marketing trực tuyến.",
      },
      {
        text: "Mục tiêu là mỗi chiến dịch đều có tính chiến lược, đo lường được hiệu quả và tạo lợi thế cạnh tranh trên thị trường số.",
        className: "mt-2",
      },
    ],
  },

  {
    slug: "to-chuc-su-kien-thuong-hieu",
    title: "Event Branding",
    topSections: [
      { title: "Xây Dựng Thương Hiệu Sự Kiện" },
      {
        text: "Chúng tôi tạo nên hệ thống nhận diện sự kiện đồng bộ và đáng nhớ, đảm bảo mọi yếu tố hình ảnh đều phản ánh đúng tinh thần và thông điệp của sự kiện.",
      },
      {
        text: "Từ biển bảng cho đến truyền thông số, đội ngũ Design24 giúp sự kiện của bạn nổi bật và để lại ấn tượng sâu sắc với người tham dự.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/to-chuc-su-kien-thuong-hieu/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Xây dựng thương hiệu sự kiện là quá trình tạo nên trải nghiệm thống nhất. Chúng tôi tập trung vào logo, phối màu, hệ thống biển bảng và ấn phẩm số để củng cố chủ đề cũng như mục tiêu của sự kiện.",
    listItems: [
      ["Thiết Kế Logo Sự Kiện", "Thiết Kế Chủ Đề", "Hệ Thống Biển Bảng"],
      ["Ấn Phẩm Truyền Thông", "Tài Nguyên Số", "Kể Chuyện Thị Giác"],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Dịch vụ Event Branding của chúng tôi đảm bảo sự đồng bộ và dễ nhận diện trên mọi điểm chạm. Kết hợp giữa sáng tạo và chiến lược, chúng tôi giúp mỗi sự kiện trở nên ấn tượng và chuyên nghiệp.",
    secondaryImages: [
      { src: "/assets/img/service/to-chuc-su-kien-thuong-hieu/1.webp", col: 8 },
      { src: "/assets/img/service/to-chuc-su-kien-thuong-hieu/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Chúng tôi giúp sự kiện toả sáng bằng hệ thống nhận diện thị giác hấp dẫn, truyền tải đúng mục tiêu và kết nối hiệu quả với người tham dự.",
      },
      {
        text: "Đội ngũ Design24 quản lý từng chi tiết để đảm bảo sự nhất quán thương hiệu và tối đa hoá hiệu quả truyền thông.",
        className: "mt-2",
      },
    ],
  },
  // Nhóm 5: Học Viện & Tư Vấn Doanh Nghiệp
  {
    slug: "hoc-vien-design24",
    title: "Học Viện Design24",
    topSections: [
      { title: "Học Viện Design24" },
      {
        text: "Học Viện Design24 tự hào cung cấp các khóa học chuyên sâu về thiết kế, truyền thông và công nghệ sáng tạo. Chúng tôi giúp học viên không chỉ nâng cao kỹ năng nghề nghiệp mà còn theo kịp xu hướng mới nhất trong ngành, từ đó phát triển sự nghiệp bền vững trong môi trường sáng tạo và cạnh tranh.",
      },
      {
        text: "Với đội ngũ giảng viên giàu kinh nghiệm thực tiễn và phương pháp giảng dạy bài bản, học viên được trang bị kiến thức từ cơ bản đến nâng cao, từ đó ứng dụng hiệu quả vào các dự án thực tế. Mỗi khóa học đều kết hợp lý thuyết và thực hành, giúp học viên nắm vững kiến thức chuyên môn và nâng cao khả năng sáng tạo.",
        extraClass: "ps-lg-5",
      },
    ],
    mainImage: "/assets/img/service/hoc-vien-design24/0.webp",
    overviewTitle: "Tổng Quan Dịch Vụ",
    overviewText:
      "Học viện Design24 chuyên cung cấp các khóa học thiết kế và truyền thông chất lượng cao, giúp học viên phát triển toàn diện về kỹ năng và khả năng sáng tạo. Chương trình đào tạo kết hợp lý thuyết và thực hành với các dự án thực tế, giúp học viên tạo ra những sản phẩm sáng tạo đáp ứng yêu cầu khắt khe của ngành nghề.",
    listItems: [
      [
        "Khóa Học Thiết Kế Logo & Branding",
        "Khóa Học Thiết Kế UI/UX",
        "Khóa Học Thiết Kế Quảng Cáo",
      ],
      [
        "Khóa Học Digital Marketing",
        "Hướng Dẫn Thực Hành Dự Án",
        "Phát Triển Portfolio Chuyên Nghiệp",
      ],
    ],
    keyFeaturesTitle: "Điểm Nổi Bật",
    keyFeaturesText:
      "Chương trình học tại Design24 được thiết kế chuyên sâu, chú trọng sự kết hợp giữa lý thuyết vững chắc và thực hành trực tiếp. Điều này đảm bảo học viên không chỉ nắm vững các kỹ năng cơ bản mà còn có thể ứng dụng ngay vào công việc thực tế, sẵn sàng cho thị trường lao động đầy cạnh tranh.",
    secondaryImages: [
      { src: "/assets/img/service/hoc-vien-design24/1.webp", col: 8 },
      { src: "/assets/img/service/hoc-vien-design24/2.webp", col: 4 },
    ],
    additionalText: [
      {
        text: "Học viên sẽ được trải nghiệm môi trường học tập tương tác, tham gia các dự án thực tế và nhận phản hồi trực tiếp từ các giảng viên chuyên nghiệp, giúp nâng cao khả năng sáng tạo và giải quyết vấn đề trong thực tế.",
      },
      {
        text: "Mục tiêu của chúng tôi là giúp học viên phát triển một cách toàn diện các kỹ năng thiết kế, truyền thông và công nghệ sáng tạo, tạo nền tảng vững chắc cho sự nghiệp tương lai trong ngành công nghiệp sáng tạo.",
        className: "mt-2",
      },
    ],
  },
];
